import { request } from "@/api/server/index";

export default {
  //V047_個人データ管理台帳画面
  PersonalInfoBook: {
    //初期表示
    indexPersonalInfoBook(params) {
      return request({
        url: "/personalInfoBook/indexPersonalInfoBook",
        data: params,
        method: "post"
      });
    },
    // 検索
    searchPersonalInfoBookList(params) {
      return request({
        url: "/personalInfoBook/searchPersonalInfoBookList",
        data: params,
        method: "post"
      });
    },
    // 個人データ管理責任者編集 初期画面
    indexPersonalDataManager(params) {
      return request({
        url: "/personalInfoBook/indexPersonalDataManager",
        data: params,
        method: "post"
      });
    },
    // 個人データ管理責任者編集 新規登録/編集
    insertOrUpdatePersonalInfoBook(params) {
      return request({
        url: "/personalInfoBook/insertOrUpdatePersonalInfoBook",
        data: params,
        method: "post"
      });
    }
  },
  //V048_個人データ管理台帳登録画面
  PersonalInfoBookEdit: {
    // 初期表示
    indexPersonalInfoBookEdit(params) {
      return request({
        url: "/personalInfoBookEdit/indexPersonalInfoBookEdit",
        data: params,
        method: "post"
      });
    },
    // 新規登録
    insertPersonalInfoBookEdit(params) {
      return request({
        url: "/personalInfoBookEdit/insertPersonalInfoBookEdit",
        data: params,
        method: "post"
      });
    },
    // 編集
    updatePersonalInfoBookEdit(params) {
      return request({
        url: "/personalInfoBookEdit/updatePersonalInfoBookEdit",
        data: params,
        method: "post"
      });
    },
    // 削除
    deletePersonalInfoBookEdit(params) {
      return request({
        url: "/personalInfoBookEdit/deletePersonalInfoBookEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V050_アクセス履歴一覧画面
  AppAccessLog: {
    //初期表示
    indexAppAccessLog(params) {
      return request({
        url: "/appAccessLog/indexAppAccessLog",
        data: params,
        method: "post"
      });
    },
    //検索(b4)ボタンをクリックしたときの処理
    searchAppAccessLogList(params) {
      return request({
        url: "/appAccessLog/searchAppAccessLogList",
        data: params,
        method: "post"
      });
    },
    //利用者リスト取得
    searchUserList(params) {
      return request({
        url: "/appAccessLog/searchUserList",
        data: params,
        method: "post"
      });
    }
  },
  //V074_持出管理台帳画面
  BringOutBook: {
    indexBringoutBook(params) {
      return request({
        url: "/bringoutBook/indexBringoutBook",
        data: params,
        method: "post"
      });
    },
    // 最初に変更，対応部署データの取得
    searchDepartmentList(params) {
      return request({
        url: "/bringoutBook/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    // 検索処理データの取得
    searchBringoutBookList(params) {
      return request({
        url: "/bringoutBook/searchBringoutBookList",
        data: params,
        method: "post"
      });
    },
    //持出確認チェック
    updateOutBringoutBook(params) {
      return request({
        url: "/bringoutBook/updateOutBringoutBook",
        data: params,
        method: "post"
      });
    },
    //持出確認チェック
    updateInBringoutBook(params) {
      return request({
        url: "/bringoutBook/updateInBringoutBook",
        data: params,
        method: "post"
      });
    },
    // 一括削除
    deleteBringoutBook(params) {
      return request({
        url: "/bringoutBook/deleteBringoutBook",
        data: params,
        method: "post"
      });
    }
  },
  //V075_持出情報登録画面
  BringOutBookEdit: {
    // 初期表示
    indexBringoutBookEdit(params) {
      return request({
        url: "/bringoutBookEdit/indexBringoutBookEdit",
        data: params,
        method: "post"
      });
    },
    // 対応部署データの取得
    searchDepartmentList(params) {
      return request({
        url: "/bringoutBookEdit/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    // (新規登録)
    insertBringoutBookEdit(params) {
      return request({
        url: "/bringoutBookEdit/insertBringoutBookEdit",
        data: params,
        method: "post"
      });
    },
    // 削除
    deleteBringoutBookEdit(params) {
      return request({
        url: "/bringoutBookEdit/deleteBringoutBookEdit",
        data: params,
        method: "post"
      });
    },
    // 登録(編集)
    updateBringoutBookEdit(params) {
      return request({
        url: "/bringoutBookEdit/updateBringoutBookEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V076_発送履歴台帳画面
  SendBook: {
    //初期化
    indexSendBook(params) {
      return request({
        url: "/sendBook/indexSendBook",
        data: params,
        method: "post"
      });
    },
    //対応部署データの取得
    searchDepartmentList(params) {
      return request({
        url: "/sendBook/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    //検索処理データの取得
    searchSendBookList(params) {
      return request({
        url: "/sendBook/searchSendBookList",
        data: params,
        method: "post"
      });
    },
    //一括削除
    deleteAllSendBook(params) {
      return request({
        url: "/sendBook/deleteAllSendBook",
        data: params,
        method: "post"
      });
    }
  },
  //V077_発送履歴登録画面
  SendBookEdit: {
    //初期表示
    indexSendBookEdit(params) {
      return request({
        url: "/sendBookEdit/indexSendBookEdit",
        data: params,
        method: "post"
      });
    },
    //部署リスト取得
    searchDepartmentList(params) {
      return request({
        url: "/sendBookEdit/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    //新規登録
    insertSendBookEdit(params) {
      return request({
        url: "/sendBookEdit/insertSendBookEdit",
        data: params,
        method: "post"
      });
    },
    //編集
    updateSendBookEdit(params) {
      return request({
        url: "/sendBookEdit/updateSendBookEdit",
        data: params,
        method: "post"
      });
    },
    //削除
    deleteSendBookEdit(params) {
      return request({
        url: "/sendBookEdit/deleteSendBookEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V078_受領履歴台帳
  ReceiveBook: {
    // 初期表示
    indexReceiveBook(params) {
      return request({
        url: "/receiveBook/indexReceiveBook",
        data: params,
        method: "post"
      });
    },
    // 「部署マスタ」リスト取得
    searchDepartmentList(params) {
      return request({
        url: "/receiveBook/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    //検索
    searchReceiveBook(params) {
      return request({
        url: "/receiveBook/searchReceiveBook",
        data: params,
        method: "post"
      });
    },
    //削除
    deleteReceiveBook(params) {
      return request({
        url: "/receiveBook/deleteReceiveBook",
        data: params,
        method: "post"
      });
    }
  },
  //V079_受領履歴台帳登録
  ReceiveBookEdit: {
    // 初期表示
    indexReceiveBookEdit(params) {
      return request({
        url: "/receiveBookEdit/indexReceiveBookEdit",
        data: params,
        method: "post"
      });
    },
    //部署リスト取得
    searchDepartmentList(params) {
      return request({
        url: "/receiveBookEdit/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    // 編集
    updateReceiveBookEdit(params) {
      return request({
        url: "/receiveBookEdit/updateReceiveBookEdit",
        data: params,
        method: "post"
      });
    },
    // 新規登録
    insertReceiveBookEdit(params) {
      return request({
        url: "/receiveBookEdit/insertReceiveBookEdit",
        data: params,
        method: "post"
      });
    },
    //削除
    deleteReceiveBookEdit(params) {
      return request({
        url: "/receiveBookEdit/deleteReceiveBookEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V090_ファイル出力ログ画面
  FileDownloadLog: {
    // 初期表示
    indexFileDownloadLog(params) {
      return request({
        url: "/fileDownloadLog/indexFileDownloadLog",
        data: params,
        method: "post"
      });
    },
    //利用者リスト取得
    searchUserList(params) {
      return request({
        url: "/fileDownloadLog/searchUserList",
        data: params,
        method: "post"
      });
    },
    //検索(b4)ボタンをクリックしたときの処理
    searchFileDownloadLogList(params) {
      return request({
        url: "/fileDownloadLog/searchFileDownloadLogList",
        data: params,
        method: "post"
      });
    }
  }
};
